<template>
    <div class="enrollment">
        <!-- <myBreadCrumb :urls="JSON.stringify(breadcrumbs)" @createForm="dialog=true"></myBreadCrumb> -->
        <create-dialog v-model="dialog" :item="item" @fetch="fetchData"></create-dialog>
        <v-card class="rounded-xl elevation-3">
            <v-card-title class="text-h6 font-weight-bold pt-4 pb-2 px-6">
                Danh sách ứng viên
                <v-spacer></v-spacer>
                
                <div class="d-flex align-center wrapper mx-1 my-1">
                    <v-btn @click="fetchData" outlined color="green lighten-3" class="rounded-lg" block style="width: 40px !important; height: 40px; padding: 0px;">
                    <v-icon color="green darken-4">mdi-refresh</v-icon></v-btn>
                </div>
                
                <v-divider vertical class="mx-4"></v-divider>

                <excel :cities="cities" :jobs="jobs" class="mx-1 d-flex"></excel>
            </v-card-title>
            
            <v-sheet class="grey lighten-4 py-6">
                <div class="d-flex flex-wrap mx-n2 px-4">
                    <v-text-field type="date" v-model="fromDate" label="Từ ngày" dense outlined class="mx-2 my-2 flex-grow-1 flex-shrink-1" style="min-width: 150px; background-color: white;" hide-details></v-text-field>
                    
                    <v-text-field type="date" v-model="toDate" label="Đến ngày" dense outlined class="mx-2 my-2 flex-grow-1 flex-shrink-1" style="min-width: 150px; background-color: white;" hide-details></v-text-field>
                    
                    <v-select label="Trạng thái" dense v-model="status" clearable :items="statuses" outlined hide-details class="mx-2 my-2 flex-grow-1 flex-shrink-1" style="min-width: 150px; background-color: white;"></v-select>
                    
                    <v-autocomplete label="Nơi làm việc" placeholder="Nhập" dense v-model="wishCityCode" clearable :items="cities" item-value="code" item-text="name" outlined hide-details class="mx-2 my-2 flex-grow-1 flex-shrink-1" style="min-width: 150px; background-color: white;"></v-autocomplete>
                    
                    <v-autocomplete label="Công việc" placeholder="Nhập" dense v-model="jobCode" clearable :items="jobs" item-value="code" item-text="name" outlined hide-details class="mx-2 my-2 flex-grow-1 flex-shrink-1" style="min-width: 150px; background-color: white;"></v-autocomplete>
                </div>
                
                <div class="d-flex justify-space-between px-4 mt-4 text-caption align-center">
                    <ul class="d-flex flex-wrap align-center" style="list-style-type: none; padding-left: 0; margin-bottom: 0;">
                        <li class="mr-4"><span class="red--text font-weight-bold">Nguyễn Văn A</span>: Nhân viên đã có trong hệ thống, nộp hồ sơ lại.</li>
                        <li><v-badge class="mr-1 mt-0" color="red" :content="2" inline></v-badge> Số lần ứng viên đã gởi hồ sơ vào hệ thống.</li>
                    </ul>
                    <v-btn dark color="teal darken-4" class="rounded-pill elevation-3 font-weight-bold px-6" @click="fetchData"> 
                        <v-icon left>mdi-filter</v-icon> Áp dụng bộ lọc 
                    </v-btn>
                </div>
            </v-sheet>
            
            <v-sheet class="px-6 py-3 d-flex align-center grey lighten-5" style="border-top: 1px solid #e0e0e0; border-bottom: 1px solid #e0e0e0;">
                <div class="subtitle-2 font-weight-bold mr-4 text-uppercase grey--text text--darken-2">Thống kê:</div>
                <v-chip color="blue lighten-4" text-color="blue darken-4" class="mr-3 font-weight-medium" small>
                    <v-icon left small>mdi-account-group-outline</v-icon>
                    Tổng ứng viên: <b class="ml-1">{{ items.length }}</b>
                </v-chip>
                <div style="flex-grow: 1;"></div>
                <v-text-field style="max-width: 300px; background-color: white;" outlined dense placeholder="Tìm kiếm ..." hint="Gõ enter để tìm kiếm" v-model="searchTemp" @keydown.enter.prevent="search=searchTemp" hide-details="auto" prepend-inner-icon="mdi-magnify" clearable @click:clear="search=''; searchTemp=''"></v-text-field>
            </v-sheet>

            <v-data-table
                :headers="headers2" :items="items"
                :expanded.sync="expanded" item-key="code"
                show-expand class="elevation-0" :loading="isLoading"
                :item-class="item => item.inSystem == 1 ? 'highlight-red-row' : ''"
                :search="search" height="calc(100vh - 400px)" fixed-header
            >
                <template v-slot:[`item.candidateInfo`]="{ item }" >
                    <div class="d-flex align-center py-1">
                        <v-avatar class="mr-3" size="40" color="grey lighten-3">
                            <v-img v-if="item.avatarUrl" :src="item.avatarUrl"></v-img>
                            <v-icon v-else :color="item.inSystem == 1 ? 'red lighten-1' : 'grey darken-1'">mdi-account</v-icon>
                        </v-avatar>
                        <div>
                            <div class="subtitle-2 font-weight-bold" style="line-height: 1.2;">
                                <v-badge v-if="item.duplicateNum > 0" color="red" :content="item.duplicateNum" inline></v-badge>
                                <span :class="item.inSystem == 1 ? 'red--text text--darken-1' : 'blue-grey--text text--darken-4'">{{item.name}}</span>
                            </div>
                            <div class="caption mt-1" :class="item.inSystem == 1 ? 'red--text text--lighten-1' : 'grey--text'">
                                {{item.code}} | <v-icon small :color="item.gender === 'Nam' ? 'blue' : 'pink'" style="font-size: 14px;">{{ item.gender === 'Nam' ? 'mdi-gender-male' : 'mdi-gender-female' }}</v-icon>
                            </div>
                        </div>
                    </div>
                </template>
                
                <template v-slot:[`item.contactInfo`]="{ item }" >
                    <div class="body-2" style="line-height: 1.4;">
                        <div><v-icon small color="blue-grey" left>mdi-phone</v-icon><span class="font-weight-medium">{{ item.phone }}</span></div>
                        <div v-if="item.mail"><v-icon small color="orange" left>mdi-email</v-icon>{{ item.mail }}</div>
                        <div v-if="item.birthday" class="mt-1"><v-icon small color="pink lighten-2" left>mdi-cake-variant</v-icon>{{ item.birthday }}</div>
                    </div>
                </template>

                <template v-slot:[`item.cityName`]="{ item }" >
                    
                    <div class="caption" style="line-height: 1.4; width: 14rem;" v-if="item.cityName">
                        {{`${item.cityName}, ${item.districtName}, ${item.wardName}, ${item.address}`}}
                    </div>
                    
                    <div class="caption d-flex align-center" style="line-height: 1.4; width: 14rem;" v-else>
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-icon x-small color="indigo darken-1" class="mr-1" v-bind="attrs" v-on="on">mdi-map-marker-radius</v-icon>
                            </template>
                            <span>Địa chỉ mới</span>
                        </v-tooltip>
                        <span>{{`${item.newCityName}, ${item.newWardName}, ${item.address}`}}</span>
                    </div>
                </template>

                <template v-slot:[`item.dCityName`]="{ item }" >
                    <div class="caption" style="line-height: 1.4; width: 14rem;">
                        {{`${item.dCityName}, ${item.dDistrictName}, ${item.dWardName}, ${item.dAddress}`}}
                    </div>
                </template>

                <template v-slot:[`item.idInfo`]="{ item }" >
                    <div class="caption" style="line-height: 1.4;">
                        <span class="font-weight-bold blue-grey--text text--darken-3">{{ item.idNumber }}</span>
                        <div class="grey--text text--darken-1" v-if="item.idDate || item.idPlace">
                            Cấp: {{ item.idDate }} <span v-if="item.idPlace">tại {{ item.idPlace }}</span>
                        </div>
                    </div>
                </template>

                <template v-slot:[`item.educationInfo`]="{ item }" >
                    <div class="caption" style="line-height: 1.4;">
                        <span class="font-weight-bold blue-grey--text text--darken-3">{{ item.universityName }}</span>
                        <div class="mt-1" v-if="item.graduateType">
                            <span class="grey--text">Xếp loại:</span>
                            <v-chip :color="formatGraduateColor(item.graduateType)" text-color="white" small class="font-weight-medium px-2 ml-1" style="height: 18px; font-size: 11px;">
                                {{ item.graduateType }}
                            </v-chip>
                        </div>
                    </div>
                </template>
                
                <template v-slot:[`item.pharmaCert`]="{ item }" >
                    <div class="caption" style="line-height: 1.4;">
                        <v-chip v-if="item.pharmaCert && item.pharmaCert !== 'KHONG'" color="teal lighten-5" text-color="teal darken-3" small class="font-weight-medium">
                            <v-icon small left>mdi-certificate</v-icon>{{ formatPharmaCert(item.pharmaCert) }}
                        </v-chip>
                        <span class="grey--text text--lighten-1" v-else>{{ formatPharmaCert(item.pharmaCert) }}</span>
                    </div>
                </template>
                
                <template v-slot:[`item.jobName`]="{ item }" >
                    <span class="font-weight-medium teal--text text--darken-3">{{ item.jobName }}</span>
                </template>
                
                <template v-slot:[`item.sentDate`]="{ item }" >
                    <div style="line-height: 1.3;"><v-icon small color="blue-grey" left>mdi-calendar</v-icon> {{ item.sentDate }}</div>
                </template>
                
                <template v-slot:[`item.status`]="{ item }" >
                    <v-chip :color="formatStatusColor(item.status)" small dark class="font-weight-bold" style="width: 100px; justify-content: center;">
                        {{formatStatus(item.status)}}
                    </v-chip>
                </template>
                
                <template v-slot:[`item.actions`]="{item}" >
                    <v-btn x-small depressed rounded color="blue-grey lighten-4" class="mx-1 my-1 blue-grey--text text--darken-3 font-weight-bold" @click="edit(item)">
                        <v-icon left small>mdi-eye</v-icon> Chi tiết
                    </v-btn>
                    <v-btn x-small depressed rounded color="green lighten-4" class="mx-1 my-1 green--text text--darken-3 font-weight-bold" @click="dialogPdf=true, pdfUrl = item.cvFileUrl">
                        <v-icon left small>mdi-file-pdf-box</v-icon> CV
                    </v-btn>
                </template>

                <template v-slot:[`item.deleteAction`]="{item}" >
                    <v-btn x-small depressed rounded class="mx-1 my-1 red--text text--darken-2 font-weight-bold" color="grey lighten-4" @click="remove(item)">
                        <v-icon left small>mdi-delete</v-icon> Xóa
                    </v-btn>
                </template>
                
                <template v-slot:expanded-item="{ headers, item }">
                    <td :colspan="headers.length" class="grey lighten-5">
                        <v-row class="ma-2">
                            <v-col cols="12" md="4">
                                <h4 class="teal--text text--darken-3 mb-2"><v-icon left color="teal">mdi-map-marker</v-icon> Địa chỉ</h4>
                                <p class="mb-1" v-if="item.dCityName!=''"><span class="font-weight-bold">Tạm trú: </span> {{`${item.dCityName}, ${item.dDistrictName}, ${item.dWardName}, ${item.dAddress}`}}</p>
                            </v-col>
                            <v-col cols="12" md="4">
                                <h4 class="teal--text text--darken-3 mb-2"><v-icon left color="teal">mdi-card-account-details</v-icon> Khác</h4>
                                <p class="mb-1"><span class="font-weight-bold">Chiều cao: </span> {{item.height}} cm | <span class="font-weight-bold">Cân nặng: </span> {{item.weight}} kg</p>
                            </v-col>
                            <v-col cols="12" md="4">
                                <p class="mb-1" v-if="item.inSystem"><v-chip class="mt-2" color="red" small dark>ĐÃ TỒN TẠI TRONG HỆ THỐNG</v-chip></p>
                            </v-col>
                        </v-row>
                    </td>
                </template>
            </v-data-table>
        </v-card>

        <!-- ************** DELETE CONFIRMATION *************** -->
        <v-dialog v-model="dialogDelete" max-width="500px">
            <v-card>
                <v-card-title class="headline">Bạn có chắc muốn xoá dữ liệu này?</v-card-title>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="dialogDelete=false">Thoát</v-btn>
                    <v-btn color="blue darken-1" text @click="cfmDeleteItem">OK</v-btn>
                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-dialog>
        
        <v-dialog v-model="dialogPdf" max-width="800px">
            <v-card>
                <v-card-title class="headline">Xem CV
                    <v-btn small class="ml-auto" @click="$refs.pdfPreview.download()" dark color="green">Tải xuống</v-btn>
                </v-card-title>
                <v-card-text class="text--primary" v-if="!!pdfUrl  && pdfUrl.includes('pdf')">
                    <embed type="text/html" :src="pdfUrl+'?ticket=' + generateRandom10DigitNumber()" width="700" height="800">
                    <vue-pdf-embed :style="'zoom:'+ zoom" ref="pdfPreview" :source="pdfUrl+'?ticket=' + generateRandom10DigitNumber()" :width="800"/>
                </v-card-text>
                <v-card-text class="text--primary" v-else>
                    <h3>Nhân viên đã không gởi file CV</h3>
                </v-card-text>
                <v-card-actions class="justify-center">
                    <v-btn  text @click="dialogPdf=false">Đóng</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import http from '@/components/services/http-common';
import myBreadCrumb from '@/components/BreadCrumb';
import DataFilter from '@/components/DataFilter';
import CreateDialog from './Create.vue';
import * as moment from "moment/moment";
import Excel from "./Excel.vue";
import VuePdfEmbed from 'vue-pdf-embed/dist/vue2-pdf-embed'

export default {
    name: "CandidateIndex",
    components: {
        VuePdfEmbed,
        myBreadCrumb,
        'data-filter': DataFilter,
        'create-dialog': CreateDialog,
        'excel': Excel,

    },
    props: ["breadcrumbs", "icon"],
    watch: {
        dialog(val) {
            this.fetchCity();
            if(!this.dialog)
                this.item=null;
        },
        tableParams: {
            handler (val) {
                this.fetchData();
            },
            deep: true,
        },
        filters: {
            handler (val) {
                this.tableParams.page=1;
                if(!val.createdAt){
                    val.createdAt = [moment().startOf('year').format("YYYY-MM-DD"), moment().endOf('month').format("YYYY-MM-DD")]
                }
                this.fetchData();
            },
            deep: true,
        },

    },
    computed: {
        params: function() {
            return {...this.tableParams, ...this.filters}
        }
    },
    data () {
        return {
            ROOT_URL: "candidates",
            endpoint: process.env.VUE_APP_BASE_URL,
            
            //filter
            tableParams: {
                sortBy: [],
                sortDesc: [],
                page: 1,
                pageSize:15
            },
            statuses: [
                {text: "Tất cả", value: ""},
                {text: "Mới", value: "NEW"},
                {text: "Chờ", value: "PEND"},
                {text: "Đạt", value: "PASS"},
                {text: "Loại", value: "FAIL"},
                {text: "Không liên hệ", value: "BLACK"},
            ],
            jobs:[],
            cities:[],
            unis:[],
            eduLvls:[],
            majors:[],
            filters:{
                code:null,
                createdAt:[moment().startOf('year').format("YYYY-MM-DD"), moment().endOf('month').format("YYYY-MM-DD")],
                status:null,
                name:null,
                bdFilter:[],
                jobCode:null,
                cityCode:null,
                city1Code:null,
                city2Code:null,
                unisCode:null,
                eduLevelCode:null,
                majorCode:null,
                phone:null,
                mail:null,
                month: moment().format("YYYY-MM"),
            },
            rowCount: 0,
            
            recruitChannels:[
                {text: "Mạng xã hội", value: "MXH"},
                {text: "Tờ rơi", value: "TR"},
                {text: "Được giới thiệu", value: "N"},
                {text: "Trang tuyển dụng", value: "TTD"},
            ],

            filter: {
                menu: false,
                search: "",
                searchAttr: "name",
                searchAttrs: undefined,
                FilterAttrs: [],
                FilterOn:["DepartmentTypeCode"],
                
                from: undefined,
                to: undefined,
                fromOns: [
                ],
                fromOn: "",
            },
            
            // VIEW DATA
            filterOpen: 1,

            //DATA TABLE
            totalItem: 0,
            items: [],
            search:"",
            searchTemp: "",
            options: {},
            isLoading: true,
            quickItem: {name: undefined, status:undefined },

            dialog: false, item: null,
            dialogDelete: false,
            dialogPdf: false,
            pdfUrl: "",
            targetItem: undefined,

            headers: [
                { text: 'Thao tác', value: 'actions',width: 120},
                { text: 'Mã', align: 'start', value: 'code', width: 100},
                // { text: "Avatar", value:"avatarUrl", align: 'center', sortable: false},
                { text: 'Ứng viên', align: 'start', value: 'name', width: 200},
                { text: 'Ngày sinh', align: 'start', value: 'birthday', width: 200},
                { text: 'Trạng thái', align: 'start', value: 'status', width: '9rem'},
                { text: 'Ngày phỏng vấn', align: 'start', value: 'interviewAt', width:'12rem'},
                { text: 'Công việc ứng tuyển', align: 'start', value: 'job', width: 200},
                { text: 'Sô CMND', align: 'start', value: 'idNumber', width: 100},
                { text: 'Nơi cấp', align: 'start', value: 'idPlace', width: 100},
                { text: 'Ngày cấp', align: 'start', value: 'idDate', width: 100},
                { text: 'Thành phố', align: 'start', value: 'city', width: 250},
                { text: 'Quận', align: 'start', value: 'district', width: 250},
                { text: 'Phường', align: 'start', value: 'ward', width: 250},
                { text: 'Địa chỉ', align: 'start', value: 'address', width: 250},
                { text: 'Phone', value: 'phone', width: 200},
                { text: 'Mail', value: 'mail', width: 200 },
                { text: 'Nơi làm việc mong muốn 1', value: 'city1', width: 200 },
                { text: 'Nơi làm việc mong muốn 2', value: 'city2', width: 200 },
                { text: 'Ngày gửi', align: 'start', value: 'createdAt', width:'12rem'},

                { text: 'Trường', value: 'university', width: 200 },
                { text: 'Học vấn', value: 'educationLevel', width: 200 },
                { text: 'Chuyên ngành', value: 'educationMajor', width: 200 },
                { text: 'Đã tồn tại trong hệ thống', value: 'inSystem', width: 200 },
            ],

            
            expanded: [],

            fromDate: moment().startOf('year').format("YYYY-MM-DD"),
            toDate:  moment().endOf('month').format("YYYY-MM-DD"),
            status:"",
            wishCityCode: "",
            jobCode:"",
            headers2: [
                { text: '', value: 'data-table-expand', filterable: false, width: '3rem' },
                { text: 'Thao tác', value: 'actions', width: '7rem', filterable: false, sortable: false},
                { text: 'Ứng viên', value: 'candidateInfo', width: '16rem'},
                { text: 'code', value: 'code', align: ' d-none', width: '16rem'},
                { text: 'name', value: 'name', align: ' d-none', width: '16rem'},
                { text: 'mail', value: 'mail', align: ' d-none', width: '16rem'},
                { text: 'phone', value: 'phone', align: ' d-none', width: '16rem'},
                { text: "Công việc", value: "jobName", width: '10rem'},
                { text: 'Trạng thái', value: 'status', width: '8rem', filterable: false},
                { text: 'Liên hệ & Ngày sinh', value: 'birthday', width: '14rem'},
                { text: 'Học vấn', value: 'educationInfo', width: '16rem', filterable: false},
                { text: 'Chứng chỉ HN', value: 'pharmaCert', width: '12rem', filterable: false},
                { text: 'Nơi lv mong muốn 1', value: 'wishCity1Name', width: '12rem' },
                { text: 'Nơi lv mong muốn 2', value: 'wishCity2Name', width: '12rem' },
                { text: 'D/c Thường trú', value: 'cityName', width: '15rem', filterable: false },
                { text: 'Thông tin CCCD', value: 'idInfo', width: '13rem', filterable: false},
                { text: 'Ngày gửi', value: 'sentDate', width: '8rem'},
                { text: 'Xóa hồ sơ', value: 'deleteAction', width: '7rem', filterable: false, sortable: false},
            ],
        }
    },
    methods: {
        generateRandom10DigitNumber() {
            const min = 1000000000; // Smallest 10-digit number (10 zeros)
            const max = 9999999999; // Largest 10-digit number (nine nines)

            return Math.floor(Math.random() * (max - min + 1)) + min;
        },
        formatPharmaCert(value) {
            if (!value) return "Không";
            const pharmaCerts = {
                "CO": "CÓ Ch.Chỉ",
                "CD": "Cao đẳng",
                "DH": "Đại học",
                "SAP": "Sắp có",
                "KHONG": "Không"
            }
            return pharmaCerts[value] || "Không"
        },
        formatGraduateColor(value) {
            if (!value) return "grey";
            const valLower = value.toLowerCase();
            if (valLower.includes('xuất sắc')) return 'deep-purple lighten-1';
            if (valLower.includes('giỏi')) return 'blue lighten-1';
            if (valLower.includes('khá')) return 'teal lighten-1';
            if (valLower.includes('trung bình')) return 'orange lighten-1';
            if (valLower.includes('yếu') || valLower.includes('kém')) return 'red lighten-1';
            return 'blue-grey lighten-1';
        },
        formatStatus(value) {
            switch(value){
                case "NEW":
                    return "Mới"
                case "PEND":
                    return "Chờ"
                case "PASS":
                    return "Đạt"
                case "FAIL":
                    return "Loại"
                case "ACCEPT":
                    return "Nhận việc"
                case "NMEET":
                    return "Không phỏng vấn"
                case "BLACK":
                    return "Không liên hệ"
            }
        },
        formatStatusColor(value) {
            switch(value){
                case "NEW":
                    return "light"
                case "PEND":
                    return "orange"
                case "PASS":
                    return "success"
                case "FAIL":
                    return "error"
                case "ACCEPT":
                    return "teal"
            }
        },
        formatDate(value) {
            return moment(value).format("DD/MM/YYYY");
        },
        fetchJob() {
            return http.get("jobs").then(res=> {
                this.jobs = res.data;
            })
        },
        fetchCity() {
            return http.get("cities/fetch").then(res=> {
                this.cities = res.data.data;
                console.log(this.cities)
            })
        },
        fetchData () {
            // return http.get(this.ROOT_URL, {
            //     params: this.params
            // })
            // .then(res => {
            //     this.isLoading = false;
            //     this.items = res.data.results;
            //     this.rowCount = res.data.rowCount;
            // })
            this.isLoading = true;
            return http.get(this.ROOT_URL+"/v2", {
                params: {
                    fromDate: this.fromDate,
                    toDate: this.toDate,
                    status: this.status,
                    wishCityCode: this.wishCityCode,
                    jobCode: this.jobCode
                }
            })
            .then(res => {
                console.log(res.data);
                this.isLoading = false;
                this.items = res.data.data;
                // this.rowCount = res.data.rowCount;
            })
        },
        fetchUni(){
            return http.get("Universities?dropDown=1").then(res => {
                this.unis = res.data
            })
        },
        fetchMajor(){
            return http.get("educationMajors?dropDown=1").then(res => {
                this.majors = res.data
            })
        },
        fetcheducationLevels(){
            return http.get("educationLevels?dropDown=1").then(res => {
                this.eduLvls = res.data
            })
        },
        edit(event ){
            this.item = event;
            this.dialog = true;
        },

        save(item){
            return http.post("candidates/quick-action/"+item.code, item).then(res=>{
                console.log(res.data);
            })
        },
        
        remove(item){
            this.dialogDelete = true;
            this.targetItem = item;
        },
        cfmDeleteItem() {
            return http.delete("candidates/"+this.targetItem.code).then(res => {
                this.fetchData();
                this.dialogDelete = false;
            })
        },
        timeFormat(val){
            return moment(val).format("YYYY-MM-DD")
        }
    },
    created() {
        this.fetchJob();
        this.fetchCity();
        this.fetchUni();
        this.fetchMajor();
        this.fetcheducationLevels();
        this.fetchData();
        this.$emit("setUrl",  this.breadcrumbs);
    },
    destroyed() {
        this.$emit("setUrl", []);
    }
}
</script>
<style scoped>
.table-cursor tbody tr:hover {
cursor: pointer;    
}

::v-deep table > tbody > tr.no-hover:hover
{
    background-color: white !important;
}

::v-deep .highlight-red-row {
    background-color: #fff0f0 !important;
}
::v-deep .highlight-red-row > td:first-child {
    border-left: 4px solid #e53935 !important;
}

::v-deep .highlight-red-row:hover {
    background-color: #ffebee !important;
}

/* ::v-deep table > tbody > tr:nth-child(1)>td {
    padding-right: 1px !important;
    padding-left: 1px !important;
} */
</style>